import bnc from "bnc";
const block = new bnc('chains-course');

export {
    block
};
